export const APP_DETAILS = [
  {
    environment: "DEV",
    version: "1.29.0",
    releaseDate: "2024/09/23",
  },
  {
    environment: "QA",
    version: "1.29.0",
    releaseDate: "2024/09/23",
  },
  {
    environment: "UAT",
    version: "1.14.1",
    releaseDate: "2024/02/05",
  },
  {
    environment: "LABS",
    version: "1.29.2",
    releaseDate: "2025/10/13",
  },
  {
    environment: "STG",
    version: "1.26.0",
    releaseDate: "2024/10/07",
  },
];
